import balance from '@/api/balance';

const state = {
    balance: '',
};

const getters = {
    balance: (state) => state.balance,
};

const actions = {
    getBalance: (context) => {
        balance
            .fetchBalance()
            .then((res) => {
                context.rootState.preloader = false;
                context.commit('BALANCE', res.body);
            })
            .catch((error) => {
                context.rootState.preloader = false;
                console.log(
                    'context.rootState.preloader',
                    context.rootState.preloader
                );
                console.log(error);
            });
    },
};

const mutations = {
    BALANCE: (state, payload) => {
        state.balance = payload;
        console.log('balance page data:', state.balance);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
